export type CityData = {
  /** Internal identifier — must match what the backend/API uses for the city field */
  city: string;
  /** Human-readable label shown in UI */
  displayName: string;
  /** Default microhub for this city, used when no specific address is selected */
  // TODO: Perhaps this shouldn't be necessary / the server can just take care of it?
  defaultMicrohubId: string;
};

export const CITIES_DATA: CityData[] = [
  { city: "Monterrey",   displayName: "Monterrey",         defaultMicrohubId: "7"  },
  { city: "Guadalajara", displayName: "Guadalajara",        defaultMicrohubId: "3"  },
  { city: "CDMX",        displayName: "Ciudad de México",   defaultMicrohubId: "80" },
  { city: "Saltillo",    displayName: "Saltillo",           defaultMicrohubId: "74"  },
  { city: "CDMX",   displayName: "Querétaro",          defaultMicrohubId: "80"  }, // HACK
];
